export enum AuthorisationTypeCode {
	STOR = 'STOR',
}
